import Router from 'vue-router';
import chttp from '@/libs/base/coupon_http';
import apis from '@/libs/base/apis';
import util from '@/libs//utils/util';
import weixin from '@/libs/app/weixin';

const charge = {
  state: {
    // 套餐信息
    charge_packages: [],
    fee_rights: {},
    // 特权信息
    rights: [],
    // 订单号
    order_id: '',
  },
  mutations: {
    SAVE_CHARGE_PACKAGE(state, data) {
      state.charge_packages = data;
      state.fee_rights = data[0];
    },
    SAVE_CHARGE_RIGHTS(state, rights) {
      state.rights = rights;
    },
    SAVE_ORDER_ID(state, orderID) {
      state.order_id = orderID;
    },
  },
  actions: {
    // 获取充值套餐信息
    getChargePackage({ commit }) {
      chttp.get(apis.getChargePackage)
        .then((res) => {
          if (res.price && res.price.length > 0) {
            commit('SAVE_CHARGE_PACKAGE', res.price);
          }
        });
    },
    // 购买充值服务
    charge({ rootState }, data) {
      const params = {
        openid: rootState.openid,
        unionid: rootState.unionid,
        id: data.packageID,
        from_type: util.getUrlPrem('fromType'),
      };
      weixin.wxPay(params, apis.getChargeOrder, {
        callback: data.callback,
      });
    },
    // 查单
    queryOrder({ state, commit, dispatch }) {
      const params = {
        order_id: state.order_id,
      };
      commit('SHOW_LOADING');
      // 会员支付查单接口
      chttp.get(apis.getChargeOrder, params)
        .then((res) => {
          if (res.is_pay) {
            commit('getBalance');
            Router.push('/thunder/customer');
          } else {
            setTimeout(() => {
              dispatch('queryOrder');
            }, 4000);
          }
        });
    },
  },
};

export default charge;
